import createCachedSelector from 're-reselect'
import { createSelector } from 'reselect'
import {
  selectCurrentEntitiesById,
  selectCurrentEntities,
  selectCurrentEntityById,
  selectCurrentEntitiesSortedBy,
  selectPendingEntitiesByIds,
} from 'ducks/entities/selectors'

import { emptyObj } from 'util/objects'
import { emptyArr } from 'util/arrays'
import { sortByKey } from 'util/arrays/sorting'
import { isAgentNotArchived } from './utils'

export const selectCurrentAgentsById = state =>
  selectCurrentEntitiesById(state, 'agent') || emptyObj

export const selectCurrentUnarchivedAgentsById = createSelector(
  selectCurrentAgentsById,
  agentsById =>
    Object.keys(agentsById).reduce((activeAgentsById, agentId) => {
      const agent = agentsById[agentId]
      if (isAgentNotArchived(agent)) {
        // eslint-disable-next-line no-param-reassign
        activeAgentsById[agentId] = agent
      }
      return activeAgentsById
    }, {})
)

export const selectCurrentAgentById = (state, id) =>
  selectCurrentEntityById(state, 'agent', id) || null

export const selectCurrentAgents = state =>
  selectCurrentEntitiesSortedBy(state, 'agent', 'name', 'asc') || emptyArr

export const selectCurrentUnarchivedAgents = createSelector(
  selectCurrentAgents,
  agents => agents.filter(isAgentNotArchived)
)

const selectCurrentTeams = state =>
  selectCurrentEntities(state, 'team') || emptyArr

export const selectCurrentUnarchivedAgentsByTeamId = createSelector(
  selectCurrentTeams,
  selectCurrentUnarchivedAgentsById,
  (teams, agentsById) => {
    return teams.reduce((byTeamId, team) => {
      sortByKey(team.agents, 'id').forEach(agent => {
        if (!byTeamId[team.id]) {
          // eslint-disable-next-line no-param-reassign
          byTeamId[team.id] = []
        }

        // Archived users could still be in the agents array of the team
        if (agentsById[agent.id]) {
          byTeamId[team.id].push(agentsById[agent.id])
        }
      })
      return byTeamId
    }, {})
  }
)

export const selectCurrentUnarchivedAgentsFilteredByTeamId = createCachedSelector(
  selectCurrentUnarchivedAgentsByTeamId,
  (_state, teamId) => teamId,
  (agentsByTeamId, teamId) => agentsByTeamId[teamId] || emptyArr
)((_state, teamId) => teamId)

export const selectPendingAgentsByIds = (state, ids) =>
  selectPendingEntitiesByIds(state, 'agent', ids)

export const selectCurrentAgentsUsernames = createSelector(
  selectCurrentAgents,
  agents => agents.map(agent => agent.username)
)
